import { atom } from 'jotai'

export const loaderCountAtom = atom(0);
export const deliveryPopupAtom = atom(false);
export const globalLoaderAtom = atom(
  (get) => get(loaderCountAtom) > 0,
  (get, set, val) => {
    const count = get(loaderCountAtom);
    set(loaderCountAtom, val ? count + 1 : Math.max(0, count - 1));
  }
);

export const alertAtom = atom({ show: false, msg: '', nextId: '' })
export const modalAtom = atom('', (get, set, value) => {
  set(modalAtom, value ?? '')
})
const readInitialValue = () => {
  const raw = localStorage.getItem(LOCAL_STORAGE_KEY)
  return raw === '0' ? false : true
}
const LOCAL_STORAGE_KEY = 'enabelBookingHistory'
const baseAtom = atom(readInitialValue())
export const enabelBookingHistoryAtom = atom(
  (get) => get(baseAtom),
  (get, set, newValue) => {
    set(baseAtom, newValue)
    const valueToStore = newValue ? '1' : '0'
    localStorage.setItem(LOCAL_STORAGE_KEY, valueToStore)
  }
)